import RegisterForm from "../components/RegisterForm";
import { useAuth } from '@features/auth/contexts/AuthContext';
import AuthLayout from "@shared/layouts/AuthLayout";
import { Navigate } from "react-router-dom";
import ThreeDotLoader from '@shared/components/ThreeDotLoader';

const RegisterPage = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="h-svh flex items-center justify-center">
        <ThreeDotLoader />
      </div>
    );
  }

  if (auth.user) {
    return <Navigate to="/" replace={true} />;
  }
  return (
    <>
      <AuthLayout>
        <RegisterForm />
      </AuthLayout>
    </>
  );
};

export default RegisterPage;
